import React from 'react'

export default function Arrrowrightop() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 9 9" fill="none"><path d="M1 8L8 1M8 1H1M8 1V8" stroke="currentColor" strokeWidth="0.5"></path></svg>
    )
}
